import { render } from "./AlertNotification.vue?vue&type=template&id=22151770"
import script from "./AlertNotification.vue?vue&type=script&lang=js"
export * from "./AlertNotification.vue?vue&type=script&lang=js"

import "./AlertNotification.vue?vue&type=style&index=0&id=22151770&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__